import React, { ReactElement, useState } from 'react'
import { Link } from 'react-router-dom'
import { ChooseTemplate } from '../../Models/ChooseTemplate'
import { ROOT_PATH } from '../../Config/Constants'
import { DeleteTemplateDocId } from '../../Util/helper';

export default function ChooseTemplateCard ({ title, subTitle, link }:ChooseTemplate) : ReactElement {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };

    const handleCardClick = () => {
        DeleteTemplateDocId(link, true);
    };
    
    return (
        <div className="card-wrapper">
            <div className="card-body-new">
                <div className="card-header-wrapper">
                    <Link 
                        onClick={handleCardClick} 
                        to={`/${ROOT_PATH}/${link}`}
                        className="template-link card-title-link"
                    >
                        <h5 className='card-title-new'>{title}</h5>
                    </Link>
                    <button 
                        className="toggle-button"
                        onClick={toggleExpand}
                        aria-label={isExpanded ? 'Collapse' : 'Expand'}
                    >
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            width="15" 
                            height="16" 
                            viewBox="0 0 14 9" 
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-chevron-down-icon lucide-chevron-down"
                            style={{
                                transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.3s ease'
                            }}
                        >
                            <path d="m1 3 6 6 6-6"/>
                        </svg>
                    </button>
                </div>
                <div 
                    className={`card-content ${isExpanded ? 'expanded' : 'collapsed'}`}
                    style={{
                        maxHeight: isExpanded ? '200px' : '0',
                        overflow: 'hidden',
                        transition: 'max-height 0.3s ease'
                    }}
                >
                    <p className="card-text-new">{subTitle}</p>
                </div>
            </div>
        </div>
    )
}
